export default __webpack_public_path__ + "static/media/servico4.8f809b4a.jpg";